// extracted by mini-css-extract-plugin
module.exports = {"checkout_summary":"CheckoutSummary_checkout_summary__1shrW","coupons":"CheckoutSummary_coupons__InRx8"};